import React, { useRef } from 'react';
import { Button } from '../../../../../components';
import { CloseOutlined, TagsOutlined, ProductOutlined, DeleteOutlined } from '@ant-design/icons';

import { BasicVMInfo } from './BasicVMInfo';
import { DetailsAndSettings } from './DetailsAndSettings';

import './DiscoveryInventoryDrawer.scss';

export const DiscoveryInventoryDrawer = ({ setDrawerOpen, record }) => {
    const scrollContainerRef = useRef(null);

    return (
        <div className="discovery-inventory-drawer" ref={scrollContainerRef}>
            <div className="discovery-inventory-drawer-header">
                {/* We will be using these buttons in the future */}
                {/* <div>
                    <Button shape="circle" icon={<TagsOutlined />} />
                    <Button shape="circle" icon={<ProductOutlined />} />
                    <Button shape="circle" icon={<DeleteOutlined />} />
                </div> */}
                <Button type="text" onClick={() => setDrawerOpen(false)} icon={<CloseOutlined />} />
            </div>
            <BasicVMInfo record={record} />
            <div className="drawer-divider" />
            <DetailsAndSettings record={record} scrollContainerRef={scrollContainerRef} />
        </div>
    );
};
